import { useEffect } from "react";

function AdLeft() {
  useEffect(() => {
    // React 렌더 완료 후 광고 DOM 안정화 시점에 로드
    const timer = setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }, 500); // 0.5초 지연
    return () => clearTimeout(timer);
  }, []);

    return (
        <div
            style={{
                width: "100%",
                minWidth: "300px",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "20px 0",
                zIndex: 0,
            }}
        >
            <style>
                {`
            @media (max-width: 1300px) { /* 400px 이하일 때 숨김 */
                .ads-container { display: none !important; }
            }
            @media (max-height: 600px) { /* 400px 이하일 때 숨김 */
                .ads-container { display: none !important; }
        `}
            </style>
            <ins
                className="adsbygoogle ads-container" // 클래스 추가
                style={{
                    display: "block",
                    width: "100%",
                    height: "600px",
                }}
            />
        </div>
    );
}

export default AdLeft;